import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { Row, Col } from "reactstrap";

import { TextInput } from "../../../components/Input";
import { CustomButton } from "../../../components/CustomButton";
import { PLACEHOLDERS, LABELS, NAMES } from "../Config";
import { FormikErrorText } from "../../../components/FormikErrorText";
import GoalStatus, { GOAL_STATUS } from "../../../constants/GoalStatus";
import { NARRATOR_VALIDATION_SCHEMA } from "../FormVaildation";
import { APP_ROUTES } from "../../../helpers/routeHelpers";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { getKey } from "../../../api/api.keys";
import { CreateNarrator, UpdateNarrator } from "../../../api/api.service";
import RadioGroupV2 from "../../../components/Input/RadioGroupV2";
import { showToast, SUCCESS } from "../../../utils/toastUtils";

let { NAME, STATUS } = LABELS;

const GOAL_STATUS_OPTIONS = Object.keys(GOAL_STATUS).map((key) => ({
    label: GoalStatus.getDisplayTextKey(GOAL_STATUS[key]),
    value: key
}));
const NarratorForm = ({ mode, data }) => {
    const history = useHistory();
    const location = useLocation();

    const id = location?.pathname?.split("/").pop() || 0;

    let { useMutate } = useRequestProcessor();

    let { mutate: addNarrator, isLoading } = useMutate("", getKey(), (data) =>
        CreateNarrator(data)
    );
    let { mutate: updateNarrator, isLoading: isUpdateNarratorLoading } = useMutate(
        "",
        getKey(),
        ({ id, bodyData }) => UpdateNarrator(id, bodyData)
    );

    // const initialValues = {
    //     [NAMES[GOAL_NAME]]: data?.name || "",
    //     [NAMES[GOAL_ORDER]]: data?.priorityNumber || "",
    //     [NAMES[GOAL_TYPE]]: data?.type
    //         ? { label: GoalTypes.getDisplayTextKey(GOAL_TYPES[data?.type]), value: data?.type }
    //         : null,
    //     [NAMES[STATUS]]: data?.status ? data?.status : null,
    //     [NAMES[SUB_CATEGORY]]: data?.labelIds?.length
    //         ? { value: data?.label?.id, label: data?.label?.title }
    //         : null
    // };

    const initialValues = {
        [NAMES[NAME]]: data?.name || "",
        [NAMES[STATUS]]: data?.status ? data?.status : null
    };

    let formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: NARRATOR_VALIDATION_SCHEMA,

        onSubmit: async (values) => {
            try {
                const bodyData = {
                    name: values?.name,
                    status:
                        values?.Status === GOAL_STATUS.ACTIVE
                            ? GOAL_STATUS.ACTIVE
                            : GOAL_STATUS.INACTIVE
                };

                if (mode === "add") {
                    addNarrator(bodyData, {
                        onSuccess: () => {
                            showToast(SUCCESS, "Narrator Added Successfully!");
                            history.push(APP_ROUTES.NARRATOR_MANAGEMENT);
                        }
                    });
                } else {
                    updateNarrator(
                        { id, bodyData },
                        {
                            onSuccess: (res) => {
                                showToast(SUCCESS, "Narrator Updated Successfully!");
                                history.push(APP_ROUTES.NARRATOR_MANAGEMENT);
                            }
                        }
                    );
                }
            } catch (error) {
                console.error("Error during form submission:", error);
            }
        }
    });

    const handleCancel = () => {
        formik.resetForm();
        history.replace(APP_ROUTES.NARRATOR_MANAGEMENT);
    };

    return (
        <form onSubmit={formik.handleSubmit} className="p-4">
            <Row>
                <Col md={12} className="my-2">
                    <TextInput
                        disabled={isLoading || isUpdateNarratorLoading}
                        placeholder={PLACEHOLDERS[LABELS.NAME]}
                        label={NAME}
                        name={NAMES[NAME]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values[NAMES[NAME]]}
                        className="hide-default-icon"
                        autoFocus
                    />
                    <FormikErrorText formikInstance={formik} fieldName={NAMES[NAME]} />
                </Col>
            </Row>

            <Row className="my-4">
                <label className="input-label">{STATUS}</label>

                <RadioGroupV2
                    field={NAMES[STATUS]}
                    name={NAMES[STATUS]}
                    value={formik.values[NAMES[STATUS]]}
                    setFieldValue={formik.setFieldValue}
                    onBlur={formik.handleBlur}
                    options={GOAL_STATUS_OPTIONS}
                />

                <FormikErrorText formikInstance={formik} fieldName={NAMES[STATUS]} />
            </Row>

            <div className="d-flex justify-content-end w-100 my-2 mt-4">
                <CustomButton
                    type="button"
                    title="Cancel"
                    className="me-3 custom-btn-sm"
                    color="primary"
                    outline
                    onClick={handleCancel}
                />
                <CustomButton
                    loading={isLoading || isUpdateNarratorLoading}
                    type="submit"
                    title={mode === "add" ? "Save" : "Update"}
                    color="primary"
                    className="shadow-theme grad-primary"
                />
            </div>
        </form>
    );
};

export default NarratorForm;
